import React from 'react';
import { MeterChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToGroupValue, buildChartTitle, buildColorScale } from "../chartHelpers";

const Index = ({chart}) => {
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData, renderChart) => {
                const data = transformToGroupValue(panelData, chart);
                const total = data.reduce((sum, e) => sum + e.value, 0);
                const colorScale = buildColorScale(data);
                const options = {
                    title: buildChartTitle(chart),
                    height: "400px",
                    meter: { proportional: { total } },
                    color: { scale: colorScale }
                };
                return renderChart(data, <MeterChart options={options} data={data} />);
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
